<p-dialog
  [header]="'medical-advice.title' | translate"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  (onHide)="resetForm()"
  [style]="{ width: '45rem', 'max-height': '75vh', 'overflow-y': 'auto' }"
>
  <div class="modal-body">
    <div class="row" [formGroup]="medicalAdviceForm">
      <div class="row mb-3">
        <div class="col-xl-6">
          <label for="callPhone" class="form-label required-star">{{
            "medical-advice.callPhone" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            placeholder="{{
              'medical-advice.callPhonePlaceholder' | translate
            }}"
            maxlength="10"
            formControlName="callPhone"
            (keypress)="onlyNumber($event)"
            (paste)="onPaste($event)"
          />
          <div
            *ngIf="
              isSubmit &&
              medicalAdviceForm.get('callPhone')?.hasError('required')
            "
            class="text-danger"
          >
            <small
              *ngIf="medicalAdviceForm.get('callPhone')?.errors?.['required']"
              >{{ "validation.required" | translate }}</small
            >
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-xl-6">
          <label for="personNo" class="form-label">{{
            "medical-advice.personNo" | translate
          }}</label>

          <app-patient-card
            (openDetailOn)="onOpenDetail($event)"
            (selectOn)="onPatientSelect($event)"
            #patientCard
          ></app-patient-card>
        </div>

        <div class="col-xl-6">
          <label class="form-label required-star" for=""
            >{{ "medical-advice.patient-fullname" | translate }}
          </label>
          <input
            type="text"
            [disabled]="lockInput"
            class="form-control"
            [placeholder]="
              'medical-advice.patient-fullname-placeholder' | translate
            "
            formControlName="personFullName"
            (input)="onStringInput($event)"
          />
          <div
            *ngIf="
              isSubmit &&
              medicalAdviceForm.get('personFullName')?.hasError('required')
            "
            class="text-danger"
          >
            <small>{{ "validation.required" | translate }}</small>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-xl-12">
          <label for="callReason" class="form-label required-star">{{
            "medical-advice.callReason" | translate
          }}</label>

          <p-dropdown
            [options]="callReasons"
            formControlName="callReason"
            [showClear]="true"
            [placeholder]="'general.select-please' | translate"
            [filter]="true"
          >
          </p-dropdown>

          <div
            *ngIf="
              isSubmit &&
              medicalAdviceForm.get('callReason')?.hasError('required')
            "
            class="text-danger"
          >
            <small
              *ngIf="medicalAdviceForm.get('callReason')?.errors?.['required']"
              >{{ "validation.required" | translate }}</small
            >
          </div>
        </div>

        <div class="col-xl-6"></div>
      </div>
      <div class="row">
        <div class="col-xl-6">
          <label for="complaint" class="form-label required-star">{{
            "medical-advice.complaint" | translate
          }}</label>
          <textarea
            class="form-control"
            rows="5"
            id="complaint"
            placeholder="{{
              'medical-advice.complaintPlaceholder' | translate
            }}"
            formControlName="complaint"
          ></textarea>
          <div
            *ngIf="
              isSubmit &&
              medicalAdviceForm.get('complaint')?.hasError('required')
            "
            class="text-danger"
          >
            <small
              *ngIf="medicalAdviceForm.get('complaint')?.errors?.['required']"
              >{{ "validation.required" | translate }}</small
            >
          </div>
        </div>
        <div class="col-xl-6">
          <label for="userNote" class="form-label">{{
            "medical-advice.userNote" | translate
          }}</label>
          <textarea
            class="form-control"
            rows="5"
            id="authorizedPersonDescription"
            placeholder="{{ 'medical-advice.userNotePlaceholder' | translate }}"
            formControlName="userNote"
          ></textarea>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-danger"
      style="margin-right: 3%"
      (click)="resetForm()"
    >
      {{ "common.cancel" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-success"
      (click)="updatedId ? updateMedicalAdvice() : saveMedicalAdvice()"
    >
      {{ (updatedId ? "common.update" : "common.save") | translate }}
    </button>
  </ng-template>
</p-dialog>

<div *ngIf="showDialog">
  <app-patient-create #createPatient></app-patient-create>
</div>
